import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import GlobalStyles from '@mui/material/GlobalStyles';
import { colorModeCss } from './theme';
import Root from './routes/root';
import LandingPage from './sections/landing-page';

import WritingsLayout from './writings/writings-layout.js';
import WritingsList from './writings/writings-list.js';
import ArticleContent from './writings/article-content.js';

import {
  createBrowserRouter,
  RouterProvider,
  Navigate
} from 'react-router-dom';

const router = createBrowserRouter([
  {
    path: '/',
    element: <Navigate to="/about-me/" replace />
  },
  {
    path: '/',
    element: <Root />,
    children: [
      {
        path: 'about-me/',
        element: <LandingPage />
      },
      {
        path: 'writings/',
        element: <WritingsLayout />,
        children: [
          {
            index: true,
            element: <WritingsList />
          },
          {
            path: ':slug',
            element: <ArticleContent />
          }
        ]
      }
    ]
  },
  {
    // Unknown or removed URLs (e.g. old /builder links) go home
    path: '*',
    element: <Navigate to="/about-me/" replace />
  }
]);

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <GlobalStyles styles={colorModeCss} />
    <RouterProvider router={router} />
  </React.StrictMode>
);
